/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isuserallowedtotogglespeaker5Inputs */

const en_entity_isuserallowedtotogglespeaker5 = /** @type {(inputs: Entity_Isuserallowedtotogglespeaker5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is User Allowed To Toggle Speaker`)
};

const de_entity_isuserallowedtotogglespeaker5 = /** @type {(inputs: Entity_Isuserallowedtotogglespeaker5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer darf Lautsprecher umschalten`)
};

/**
* | output |
* | --- |
* | "Is User Allowed To Toggle Speaker" |
*
* @param {Entity_Isuserallowedtotogglespeaker5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isuserallowedtotogglespeaker5 = /** @type {((inputs?: Entity_Isuserallowedtotogglespeaker5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isuserallowedtotogglespeaker5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isuserallowedtotogglespeaker5(inputs)
	return de_entity_isuserallowedtotogglespeaker5(inputs)
});
export { entity_isuserallowedtotogglespeaker5 as "entity_isUserAllowedToToggleSpeaker" }